var _style, _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKarabamaLogo5Cf90918(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 111.9 46.4",
    style: {
      enableBackground: "new 0 0 111.9 46.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:url(#SVGID_1_);} .st1{fill:url(#SVGID_2_);} .st2{fill:url(#SVGID_3_);} .st3{fill:url(#SVGID_4_);} .st4{fill:url(#SVGID_5_);} .st5{fill:#fff;} ")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.3618,
    y1: 37.2018,
    x2: 75.6082,
    y2: 37.2018
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F47D20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4521,
    style: {
      stopColor: "#F9A01B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFD100"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.4,28.4c-0.7,2.4-1.6,4.7-2.9,6.8C99,39.6,95.3,43.3,90.7,46L90,46.4L89.3,46C82.5,42,77.6,35.5,75.6,28 c2.1,6,7.8,10.3,14.4,10.3C96.6,38.3,102.2,34.2,104.4,28.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.7582,
    y1: 29.485,
    x2: 105.2976,
    y2: 29.485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F47D20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01244473,
    style: {
      stopColor: "#F57E20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4795,
    style: {
      stopColor: "#FBAA19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8215,
    style: {
      stopColor: "#FFC60A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFD100"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.9,20.7c0,0.6,0,1.4,0,1.6c0,1.3-0.4,2.5-1,3.6c-1.7,3.9-5.7,6.6-10.2,6.6c-5.6,0-10.2-4.1-11-9.4 c0,0.1,0,0.2,0,0.4c0.2,1.6,0.4,3.1,0.8,4.6c2.1,6,7.8,10.3,14.4,10.3c6.6,0,12.1-4.1,14.3-9.9c0.3-1.2,0.6-2.4,0.8-3.6 c0.2-1.3,0.2-2.7,0-4c0,0,0,0,0,0H96.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.9896,
    y1: 26.576,
    x2: 74.6138,
    y2: 26.576
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F47D20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1516,
    style: {
      stopColor: "#F58120"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3573,
    style: {
      stopColor: "#F78D1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5938,
    style: {
      stopColor: "#F9A11B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8515,
    style: {
      stopColor: "#FEBE10"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFD100"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.9,29.3c-3.9,0-7-3.2-7-7c0-0.5,0.1-1,0.2-1.5h-8.4c0,0.1,0,0.2,0,0.3v0c0,0.5,0,1.6,0.1,2.1 c0.9,5.3,5.5,9.3,11.1,9.3c4.6,0,8.5-2.7,10.2-6.6C94.8,27.9,92.5,29.3,89.9,29.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.6247,
    y1: 9.4413,
    x2: 105.1382,
    y2: 9.4413
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CB5E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    style: {
      stopColor: "#63AEE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2934,
    style: {
      stopColor: "#499BD5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5257,
    style: {
      stopColor: "#0081C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5674,
    style: {
      stopColor: "#007CC2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#002E65"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M95.4,3.1l-2.2,6.6c-0.1,0.2-0.3,0.1-0.3-0.1l0.4-7.3c0-0.3-0.2-0.6-0.5-0.7c-0.9-0.1-2.1-0.2-2.9-0.2 c-0.8,0-1.9,0.1-2.7,0.2c-0.3,0-0.6,0.3-0.5,0.7L87,9.7c0,0.2-0.2,0.2-0.3,0.1l-2.2-6.7c-5.8,2.2-9.9,7.7-9.9,14.3h30.5 C105.1,10.9,101.1,5.3,95.4,3.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.2452,
    y1: 13.3674,
    x2: 89.1949,
    y2: 23.0133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6CB5E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    style: {
      stopColor: "#63AEE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2934,
    style: {
      stopColor: "#499BD5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5257,
    style: {
      stopColor: "#0081C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5674,
    style: {
      stopColor: "#007CC2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#002E65"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M72.9,19.5h34.2v0c0-1.9-1.6-3.5-3.5-3.5H76.3C74.4,16.1,72.9,17.6,72.9,19.5L72.9,19.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M33.5,31.1h-5.5c-3.1,0-5.7-2.5-5.7-5.7v-7.2l2.8-0.7v7.9c0,1.6,1.3,2.9,2.9,2.9h2.8v-6.9l2.8-0.7V31.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M20,31.1h-7.5l1.2-2.8h3.5V26c0-1.3-1.1-2.4-2.4-2.4h-3.1v7.6H7.4c-3.1,0-5.7-2.5-5.7-5.7v-7.2l2.8-0.7v7.9 c0,1.6,1.3,2.9,2.9,2.9H9v-7.6h5.9c2.8,0,5.2,2.3,5.2,5.2V31.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M16.5,18.9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.6,
    y: 32.3,
    className: "st5",
    width: 2.8,
    height: 2.8
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "58.6,19.8 63.2,13.1 59.7,13.1 55.1,19.8 "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M68.6,31.1H53.3c-3.1,0-5.7-2.5-5.7-5.7v-7.2l2.8-0.7v7.9c0,1.6,1.3,2.9,2.9,2.9h12.5l0-2.5 c0-1.3-1.1-2.4-2.4-2.4H53l1.7-2.8h8.7c2.8,0,5.1,2.3,5.1,5.1L68.6,31.1z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "39.7,31.1 36.9,31.1 36.9,18.3 39.7,17.5 "
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M42.5,21.4V30c0,0.9-0.4,1.7-1.1,2.3v2.8c2.2-0.8,3.9-2.9,3.9-5.4v-9L42.5,21.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKarabamaLogo5Cf90918);
export default __webpack_public_path__ + "static/media/karabama-logo.5cf90918.f9b4a06266e27837501acf652b9ea840.svg";
export { ForwardRef as ReactComponent };